import { useApolloClient } from "@apollo/client/react";
import React, { useEffect, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useRecoilValue } from "recoil";
import ApplicationForm from "../components/Form/ApplicationForm";
import Template from "../components/Layout/Template";
import Loading from "../components/Loading";
import NotFound from "../components/NotFound";
import ProtectedRoute from "../components/ProtectedRoute";
import { validateUser } from "../graphql/query";
import LoginAdmin from "../pages/Admin/Login/LoginAdmin";
import Assesment from "../pages/User/Dashboard/Assesment";
import Mostest1 from "../pages/User/Dashboard/Assesment/Mostest1";
import SimulationTest from "../pages/User/Dashboard/Assesment/Mostest1/SimulationTest";
import CFIT from "../pages/User/Dashboard/CFIT";
import Dashboard from "../pages/User/Dashboard/Dashboard";
import JobLists from "../pages/User/Dashboard/JobLists";
import Papikostik from "../pages/User/Dashboard/Papikostik";
import { PreAssesment } from "../pages/User/Dashboard/PreAssesment";
import Career from "../pages/User/Home/Career";
import Home from "../pages/User/Home/Home";
import Login from "../pages/User/Login/Login";
import { isLoggedInSelector, userDataSelector } from "../shared/globalStates";
import { removeToken } from "../shared/helpers";
import { useValidateUser } from "../shared/hooks/useValidateUser";
import RouterAdmin from "./admin";

function MainRoute() {
  const isLoggedIn = useRecoilValue(isLoggedInSelector);
  const userData = useRecoilValue(userDataSelector);
  const [withAuth, setWithAuth] = useState(false);
  const validate = useValidateUser();

  useEffect(() => {
    validate.then((result) => {
      if (result) {
        setWithAuth(true);
      } else {
        setWithAuth(false);
        removeToken();
      }
    });
  }, [isLoggedIn, validate]);

  return (
    <React.Fragment>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Switch>
        <Route exact path="/">
          {userData?.is_admin ? <Redirect to="/Admin" /> : <Home />}
        </Route>
        <Route exact path="/explorejobs">
          {userData?.is_admin ? <Redirect to="/Admin" /> : <Career />}
        </Route>
        <Route exact path="/Admin/login">
          <LoginAdmin />
        </Route>
        <Route exact path="/login">
          {isLoggedIn && withAuth ? <Redirect to="/career/home" /> : <Login />}
        </Route>
        <Route exact path="/application-form">
          <ApplicationForm />
        </Route>
        <Route path="/career*">
          <DashboardRoute
            login={isLoggedIn}
            auth={withAuth}
            user={userData}
            setWithAuth={setWithAuth}
          />
        </Route>
        <Route path="/Admin*">
          <RouterAdmin />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </React.Fragment>
  );
}

export function DashboardRoute({ login, auth, user, setWithAuth }) {
  const client = useApolloClient();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    if (login) {
      validateUser(client)
        .then((response) => {
          if (response === true) {
            setWithAuth(response);
          } else {
            setWithAuth(false);
            removeToken();
          }
        })
        .catch(() => {
          setWithAuth(false);
          removeToken();
        });
    }
    setLoading(false);
  }, []);

  return loading ? (
    <Loading />
  ) : !user ? (
    <Redirect to="/login" />
  ) : user?.is_admin ? (
    <Redirect to="/Admin" />
  ) : (
    <React.Fragment>
      <ProtectedRoute path="/career">
        <Template>
          <ProtectedRoute path="/career/home" exact>
            <Dashboard />
          </ProtectedRoute>
          <ProtectedRoute path="/career/joblist" exact>
            <JobLists />
          </ProtectedRoute>
          <ProtectedRoute path="/career/assessment" exact>
            <Assesment />
          </ProtectedRoute>
          <ProtectedRoute path="/career/pre-assessment" exact>
            <PreAssesment />
          </ProtectedRoute>
          <ProtectedRoute path="/career/mostest-1/" exact>
            <CFIT />
          </ProtectedRoute>
          <ProtectedRoute path="/career/mostest-1/:id" exact>
            <Mostest1 />
          </ProtectedRoute>
          <ProtectedRoute path="/career/mostest-2" exact>
            <Papikostik />
          </ProtectedRoute>
          <ProtectedRoute path="/career/percobaan" exact>
            <SimulationTest />
          </ProtectedRoute>
        </Template>
      </ProtectedRoute>
    </React.Fragment>
  );
}

// import React from "react";
// import { Redirect, Route, Switch } from "react-router-dom";
// import Dashboard from "../pages/Admin/Dashboard/Dashboard";
// import Candidate from "../pages/Admin/Candidate/Candidate";
// // import Login from "../pages/Login/Login";
// import { useRecoilValue } from "recoil";
// import { userDataSelector } from "../shared/atoms/authTokenAtom";
// import Division from "../pages/Admin/Division/Division";

// function AdminRouter() {
//     return (
//         <Switch>
//             <PrivateRoute exact path="/Admin">
//                 <Dashboard />
//             </PrivateRoute>
//             <PrivateRoute path="/Admin/division">
//                 <Division />
//             </PrivateRoute>
//             <PrivateRoute path="/Admin/candidates/:opportunityID">
//                 <Candidate />
//             </PrivateRoute>
//         </Switch>
//     );
// }

// function PrivateRoute({ children, ...rest }) {
//     const authLogin = useRecoilValue(userDataSelector);

//     return (
//         <Route
//             {...rest}
//             render={({ location }) => {
//                 return authLogin?.is_admin === true ? (
//                     children
//                 ) : (
//                     <Redirect
//                         to={{
//                             pathname: "/Admin/login",
//                             state: { from: location },
//                         }}
//                     />
//                 );
//             }}
//         />
//     );
// }

// export default Router;

export default MainRoute;
